// extracted by mini-css-extract-plugin
export var left = "HeadingWithSubHeading-module--left--2f0Og";
export var center = "HeadingWithSubHeading-module--center--2p_hm";
export var right = "HeadingWithSubHeading-module--right--2XIjF";
export var row = "HeadingWithSubHeading-module--row--2Yk6b";
export var icon = "HeadingWithSubHeading-module--icon--_rkG-";
export var subheading = "HeadingWithSubHeading-module--subheading--fhStm";
export var contrast__primary = "HeadingWithSubHeading-module--contrast__primary--fd2Y0";
export var contrast__alt = "HeadingWithSubHeading-module--contrast__alt--3jht9";